const steps = [
  {
    title: "Brief",
    text: "You tell me which sites, which fields and how often. I check what is feasible and what blocks to expect.",
  },
  {
    title: "Build",
    text: "I write the scraper and the API or database around it, with logging and retries from day one.",
  },
  {
    title: "Deliver",
    text: "Data arrives as JSON, CSV or through an API, on a schedule that fits your workflow.",
  },
  {
    title: "Maintain",
    text: "Sites change. I monitor failures and fix selectors and anti-bot issues as they appear.",
  },
];

const Process = () => (
  <section className="py-20 lg:py-24 bg-dark-900/40 text-light-100 border-t border-dark-600">
    <div className="container mx-auto px-6">
      <div className="max-w-3xl mb-14">
        <p className="font-code text-sm text-primary-400 mb-3">Process</p>
        <h2 className="text-3xl md:text-4xl font-bold">How a project runs</h2>
      </div>

      <ol className="grid gap-px bg-dark-600 border border-dark-600 rounded-lg overflow-hidden md:grid-cols-2 lg:grid-cols-4">
        {steps.map((step, i) => (
          <li key={step.title} className="bg-dark-900 p-6">
            <span className="font-code text-sm text-amber-400">
              Step {i + 1}
            </span>
            <h3 className="mt-3 mb-2 text-xl font-semibold">{step.title}</h3>
            <p className="text-gray-400 text-sm">{step.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default Process;
